//MUI
import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';

export const CurrencyBar = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '100%',
    margin: 'auto',
    padding: 0,
    position: 'absolute',
    '& .balanceItemWrap': {
      minWidth: '33%',
      alignItems: 'center',
      display: 'flex',
    },
    '& .balanceItem': {
      margin: 'auto',
    },
  },
  padding: '0 24px',
  flexDirection: 'row',
  height: '84px',
  borderBottom: `1px solid ${theme.palette.root.brandSecondary_012}`,
}));

export const BalancesBar = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  transition: theme.transitions.create('left', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),
  position: 'absolute',
}));

export const CurrencyWrap = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  overflowX: 'auto',
  '& .arrowGallery': {
    zIndex: 100,
    width: '12px',
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));
